export const AUTHORIZATION = "Authorization";
export const NEXT_LOCALE = "NEXT_LOCALE";
export const PSP_COOKIE = "psp";
